import { render, staticRenderFns } from "./ItineraryIntroductorySection.vue?vue&type=template&id=6839dd29&scoped=true&"
import script from "./ItineraryIntroductorySection.vue?vue&type=script&lang=js&"
export * from "./ItineraryIntroductorySection.vue?vue&type=script&lang=js&"
import style0 from "./ItineraryIntroductorySection.vue?vue&type=style&index=0&id=6839dd29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6839dd29",
  null
  
)

export default component.exports